export default __webpack_public_path__ + "static/media/01-NBA-Logo.c891bff2.jpg";